function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

export { _inheritsLoose as inheritsLoose };
//# sourceMappingURL=_rollupPluginBabelHelpers.js.map
